










import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
export default class ProjectsCount extends Vue {
  @Prop({ required: true }) label!: string;
  @Prop({ required: true }) count!: number;
  @Prop({ required: true }) variant!: "future" | "pending";

  get iconClassName(): string | null {
    if (["future", "pending"].includes(this.variant)) {
      return `bg-${this.variant}`;
    }
    return null;
  }
}
